// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"MenuTitle_wrapper__3qJxc","title":"MenuTitle_title__3kKpx","bold":"MenuTitle_bold__2GfeP"};